import { render, staticRenderFns } from "./EposServicesComponent.vue?vue&type=template&id=578e2f46"
import script from "./EposServicesComponent.vue?vue&type=script&lang=js"
export * from "./EposServicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports